var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-form-model-item',{staticClass:"query__item",attrs:{"label":_vm.label}},[_c('div',{staticStyle:{"width":"200px"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }